export default function KPI({ icon: Icon, k, v, sub, highlight, testid }) {
  return (
    <div data-testid={testid} className={`border rounded-2xl p-4 ${highlight ? "bg-ink text-cream border-ink" : "bg-cream-card hairline"}`}>
      <div className="flex items-center gap-2 mb-2">
        {Icon && <Icon className="w-4 h-4 text-coral" strokeWidth={1.7} />}
        <p className={`font-mono text-[10px] uppercase tracking-[0.25em] ${highlight ? "text-cream/70" : "text-ink-mid"}`}>{v}</p>
      </div>
      <p className="font-serif text-3xl tracking-tighter">{k}</p>
      {sub && (
        <p className={`mt-1 text-[11px] ${highlight ? "text-cream/60" : "text-ink-mid"}`}>{sub}</p>
      )}
    </div>
  );
}
